import React, { Component } from 'react';
import ReportHeader from '../../ReportHeader'
import ReportHeader2 from '../../ReportHeader2'
import ReportHeader3 from '../../ReportHeader3'
import Section from '../../ReportSection/index'
  import SuccessStatus from '../../SuccessStatus/index'
import ErrorTable from '../ErrorTable'
import T from 'i18n-react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import {
  Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import _ from 'lodash'
import { connect } from 'react-redux'
import { downloadFiles } from 'containers/Project/NvqualSection/actions'
import { compose } from 'recompose';

const mapDispatchToProps = (dispatch) => {
  return {
      onDownloadFile: (files, name) => dispatch(downloadFiles(files, name))
  }
}

class NvlinkBandwidthTest extends Component {

    constructor(props) {
      super(props)
      this.state = {
        curRun: 0
      }
    }

    renderAdditionalErrorInformation (errorType, info) {
    }

    renderResultTable(data) {
      return (
        <Table selectable={false}>
          <TableHead key={`head`}>
            <TableCell key={`source`}>Source</TableCell>
            <TableCell key={`remote`}>Remote</TableCell>
            <TableCell key={`direction`}>Direction</TableCell>
            <TableCell key={`bandwidth`}>Theoretical Bandwidth (%)</TableCell>
          </TableHead>
          {data.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell key={`source${idx}`}>
                <code>{row.sourceGpu}</code> <code>{row.sourceLink}</code>
              </TableCell>
              <TableCell key={`remote${idx}`}>
                <code>{row.remoteGpu}</code> <code>{row.remoteLink}</code>
              </TableCell>
              <TableCell key={`direction${idx}`}>{row.measurementDirection}</TableCell>
              <TableCell key={`bandwidth${idx}`}>{row.percentageBandwidth}</TableCell>
            </TableRow>
          ))}
        </Table>
      )
    }

    getRunSource = (runs) => 
    runs.map((x, idx) => {
        return {value: idx, label: `Run ${idx + 1}`}
      })

    onCurRunChange = (newVal) => {
      this.setState({
        curRun: newVal
      })
    }

    render(){
        const { curRun } = this.state
        const { error, onDownloadFile, files, testName, testId, result } = this.props
        const runs = _.get(this.props, `data[0].runs`, [])
        const curRunInfo = _.get(this.props, `data[0].runs[${curRun}]`, null)
        const hasErrorData = error && error.length > 0

        return(
        <Section>
            <ReportHeader 
             title={T.translate(`containers.project.nvqualSection.test.${testId}`)}
             showDownload
                  onDownloadClick={onDownloadFile.bind(this, files.map((f) => f.id), testName)}/>
            <Section>
                <ReportHeader2 title={'Summary'} />
                <Section>
                <SuccessStatus result={result} />
                {hasErrorData && 
                  <React.Fragment>
                  <ReportHeader3 title={'Errors'} />
                      <ErrorTable
                          errors={error}
                          errorSpecificRenderFunc={this.renderAdditionalErrorInformation} />
                  </React.Fragment>}
                </Section>
            </Section>
            <Section>
                <ReportHeader2 title={'Test Results'} 
                          showDropdown
                          value={curRun}
                          source={this.getRunSource(runs)}
                          onChange={this.onCurRunChange}/>
                <Section>
                  <ReportHeader3 title={'Results'} />
                  {curRunInfo && this.renderResultTable(curRunInfo.data)}
                </Section>
            </Section>
        </Section>
        );
    }
    }

    const withConnect = connect(null, mapDispatchToProps)
    const withStyles = CSSModules(styles);
    const enhance = compose(withConnect, withStyles);
    export default enhance(NvlinkBandwidthTest);
